import { SoftwallRecoveredType } from "../types";
import { isExpired } from "../utils";

export const isSessionRecovered = (
  recovered: SoftwallRecoveredType,
  attributionExpiry: number,
): boolean => {
  const isAttrExpired = isExpired(attributionExpiry);
  const isRecovered = recovered === "AB" || recovered === "SCA";
  return isRecovered && !isAttrExpired;
};
